import React from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import './Legal.css';

export default function DataDeletion() {
  const [params] = useSearchParams();
  const code = params.get('code');

  return (
    <div className="legal-page">
      <header className="legal-header">
        <div className="legal-header-inner container">
          <Link to="/" className="legal-logo">Solvi</Link>
        </div>
      </header>

      <main className="legal-main container">
        <div className="deletion-status">
          <h1>Data Deletion Request</h1>

          {code ? (
            <>
              <p>
                We have received your data deletion request. All Facebook-linked data
                associated with your account — including page access tokens, connected
                channels, and conversation history — will be permanently deleted within
                <strong> 30 days</strong>.
              </p>
              <p>Your confirmation code:</p>
              <span className="deletion-code">{code}</span>
              <p style={{ marginTop: '1rem' }}>
                Keep this code for your records. If you have questions, email{' '}
                <a href="mailto:support@solvi.chat">support@solvi.chat</a> with this code.
              </p>
            </>
          ) : (
            <>
              <p>
                To request deletion of your Facebook-linked data, go to your Facebook settings:
              </p>
              <p>
                <strong>Settings &amp; Privacy → Settings → Apps and Websites → Solvi → Remove</strong>
              </p>
              <p>
                Alternatively, email <a href="mailto:support@solvi.chat">support@solvi.chat</a>{' '}
                and we will process your request within 30 days.
              </p>
            </>
          )}
        </div>
      </main>

      <footer className="legal-footer">
        <div className="container">
          <p>© {new Date().getFullYear()} Solvi. <Link to="/terms">Terms</Link> · <Link to="/privacy">Privacy</Link></p>
        </div>
      </footer>
    </div>
  );
}
